const extractIndoorMapLink = (hrl = "") => {
  const lines = hrl.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  let floor = "", room = "";
  const otherLines = [];

  for (const line of lines) {
    if (line.startsWith("Floor:")) {
      floor = line.replace("Floor:", "").trim();
    } else if (line.startsWith("Room:")) {
      room = line.replace("Room:", "").trim();
    } else {
      otherLines.push(line);
    }
  }

  // Return structured data instead of HTML strings
  return {
    mapLink: null,
    parsedData: {
      floor,
      room,
      otherLines
    }
  };
};

const extractEmbeddedMapLink = (payload) =>
  payload?.rankedLocations?.[0]?.dispatchableAddress?.mapLink
  || payload?.rankedLocations?.[0]?.mapLink
  || null;

export { extractEmbeddedMapLink, extractIndoorMapLink };
